/**
 * Generates the self-service password reset deep link.
 * Same-origin /loginauth link — ss-ui-node redirects central-auth requests to SSAS,
 * forwarding the flow params below so changePassword arrives pre-selected.
 *
 * Identical function from:
 * - ss-ui-client/src/services/password-reset-link-generator.js
 */
export const generatePasswordResetLink = (username: string): string => {
  const encodedUsername = encodeURIComponent(username);
  return `/loginauth?flow=changePassword&username_or_email=${encodedUsername}&auto_invoke=true&voluntary=true`;
};
